import React from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { getQuestionScore, getStudentScore, getTotalScore } from '../../../util/mission';
import ScorePieChart from './ScorePieChart';
import ScoreDistributionChart from './ScoreDistributionChart';
import AbilityPointsRadarChart from './AbilityPointsRadarChart';
import { ABILITY_POINTS_DICT } from '../../../dto/chart';
import AbilityPieChart from './AbilityPointPieChart';

function Component(props) {
    const { id,schoolId } = useParams();
    const navigate = useNavigate();

    let [searchParams, setSearchParams] = useSearchParams();
    const filter= searchParams.get('class')|| '全部';


    const school = props.school||{}
    const mission = props.mission||{}
    const data = filter==='全部'?(props.data||[]):props.data?.filter((item)=>item?.student?.class===filter);

    const getAverageScore = () => {
        let totalScore = 0;
        for(let i = 0; i < data?.length; i++) {
            totalScore += (getStudentScore(data[i]?.questions)||0);
        }
        return Math.round((totalScore / data?.length)*100)/100;
    }
    const getLowestScore = () => {
        let lowestScore = getTotalScore(mission?.questions);
        for(let i = 0; i < data?.length; i++) {
            const score = getStudentScore(data[i]?.questions);
            if(score < lowestScore) {
                lowestScore = score;
            }
        }
        return Math.round(lowestScore*100)/100;
    }
    const getHighestScore = () => {
        let highestScore = 0;
        for(let i = 0; i < data?.length; i++) {
            const score = getStudentScore(data[i]?.questions);
            if(score > highestScore) {
                highestScore = score;
            }
        }
        return Math.round(highestScore*100)/100;
    }
    const getScoreArray = () => {
        let scoreArray = [];
        for(let i = 0; i < data?.length; i++) {
            const score = getStudentScore(data[i]?.questions);
            scoreArray.push(score);
        }
        return scoreArray;
    }

    const getAbilityPointsLabel = () => {
        let array = [];
        for(let i = 0; i < mission?.questions?.length; i++) {
            const question = mission?.questions[i];
            if((!['短句作答題', '選擇題 + 短句作答題'].includes(question.type))&&question.score>0 && question?.abilityPoint && !array.includes(question.abilityPoint)) {
                array.push(question.abilityPoint);
            }
        }
        return array;
    }

    const getAbilityPointsData = () => {
        let array = [];
        for(let label of getAbilityPointsLabel()) {
            let total=0
            let count=0
            for(let i = 0; i < data?.length; i++) {
                if(data[i]?.questions) {
                    for(let j = 0; j < data[i]?.questions.length; j++) {
                        const question = data[i]?.questions[j];
                        if(mission?.questions?.[j]?.abilityPoint === label) {
                            let studentScore = getQuestionScore(question);
                            let questionScore = question.score||0;
                            if(questionScore > 0) {
                                total += questionScore;
                                count += studentScore;
                            }
                            
                        }
                    }
                }
            }
            array.push({
                total,count,label,
            });
        }
        return array;
    }
    const getClassList = () => {
        let array = [];
        for(let i = 0; i < props.data?.length; i++) {
            const student = props.data[i].student;
            if(student?.class && !array.includes(student.class)) {
                array.push(student.class);
            }
        }
        return array.sort((a,b)=>a>b?1:-1);
    }

    if(data.length===0) return(
        <div className='h-full flex-1 bg-[#F2F2F2] flex-col flex p-[16px] gap-[16px]' style={{ overflowY: "auto" }}>
            <div className='p-[16px] flex flex-row items-center justify-between items-center bg-[white] rounded-[10px] gap-[8px] flex-wrap'>
                <div className='text-[#212121] text-[20px] font-[700]'>沒有任何學生的成績</div>
                
            </div>
        </div>
    )
    return (
        <div className='h-full flex-1 bg-[#F2F2F2] flex-col flex p-[16px] gap-[16px]' style={{ overflowY: "auto" }}>
            {/*title, filter, serach box*/}
            <div className='p-[16px] flex flex-row items-center justify-between items-center bg-[white] rounded-[10px] gap-[8px] flex-wrap'>
                <div className='text-[#212121] text-[20px] font-[700]'>閲讀任務名稱: {mission?.name}</div>
                {props.school&&<div className='text-[#212121] text-[20px] font-[700]'>學校名稱: {school?.name}</div>}
                <div className='flex flex-row items-center gap-[8px] flex-wrap'>
                    {props.school?
                        <div className='cursor-pointer text-[blue] underline text-[12px]' onClick={()=>{navigate(`/platform2/results/${id}/${schoolId}`)}}>返回</div>
                        :<div className='cursor-pointer text-[blue] underline text-[12px]' onClick={()=>{navigate(`/platform2/results/${id}`)}}>返回</div>
        }
                </div>
            </div>
            {/*end of title, filter, serach box*/}

            {/*status filter*/}
            <div className='flex flex-row w-full bg-[white] rounded-[10px] p-[16px] text-[14px] flex-wrap gap-[16px] justify-start' style={{  }}>
                班級: <div className='cursor-pointer px-[8px]' onClick={()=>{setSearchParams({class:'全部'})}} style={{color:filter==='全部'?'#1F4CC8':'#898989',fontWeight:filter==='全部'?700:300}}>全部</div>
                {getClassList().map((item,index)=>
                    <div key={index} className='cursor-pointer px-[8px]' onClick={()=>{setSearchParams({class:item})}} style={{color:filter===item?'#1F4CC8':'#898989',fontWeight:filter===item?700:300}}>{item}</div>
                )}

                <div className='flex-1 flex flex-row gap-[24px justify-end items-center gap-[14px]'>學生總數:
                    <div className='text-[16px] font-[700]'>{data?.length}</div>
                </div>
            </div>

            <div className='flex flex-row w-full bg-[white] rounded-[10px] p-[16px] text-[14px] flex-wrap gap-[16px]' style={{  }}>
                <div className='w-[400px] min-w-[400px] flex flex-col'>
                    <div className='w-full pb-[4px]' style={{borderBottom:'1.5px solid #ccc'}}>平均成績</div>
                    <div className='w-full flex flex-row items-center justify-center'>
                        <ScorePieChart 
                            average={getAverageScore()/getTotalScore(mission?.questions)}
                            averageText={getAverageScore()}
                            lower={getLowestScore()/getTotalScore(mission?.questions)}
                            lowerText={getLowestScore()}
                            higher={getHighestScore()/getTotalScore(mission?.questions)}
                            higherText={getHighestScore()}/>
                        <div className='w-[160px] text-[12px] h-full flex flex-col justify-center items-center gap-[8px]'>
                            <div className='w-full flex flex-row items-center gap-[8px] justify-center'>
                                平均分數
                                <div className='text-[24px] w-[100px] text-center'>{getAverageScore()}/{getTotalScore(mission?.questions)}</div>
                            </div>
                            <div className='w-full flex flex-row items-center gap-[8px] justify-center'>
                                最低分數
                                <div className='text-[24px] w-[100px] text-center'>{getLowestScore()}/{getTotalScore(mission?.questions)}</div>
                            </div>
                            <div className='w-full flex flex-row items-center gap-[8px] justify-center'>
                                最高分數
                                <div className='text-[24px] w-[100px] text-center'>{getHighestScore()}/{getTotalScore(mission?.questions)}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='flex-1 flex flex-col min-w-[400px]'>
                    <div className='w-full pb-[4px]' style={{borderBottom:'1.5px solid #ccc'}}>成績分佈</div>
                    <div className='w-full flex-1 flex flex-row items-center justify-center'>
                       <ScoreDistributionChart max={getTotalScore(mission?.questions)||10} data={getScoreArray()}/>
                    </div>
                </div>
            </div>

            <div className='flex flex-row w-full items-stretch gap-[16px] flex-wrap'>
                <div className='flex-1 max-w-[400px] min-w-[400px] flex flex-col bg-[white] rounded-[10px] p-[16px] text-[14px] justify-start items-center'>
                    <div className='w-full pb-[4px]'>成績能力點</div>
                    <AbilityPointsRadarChart data={getAbilityPointsData()}/>
                    <div className='w-full flex flex-col items-center justify-center gap-[8px]'>
                        {getAbilityPointsLabel().map((item,index)=>
                            <div key={index} className='w-full flex flex-col items-start gap-[8px] justify-center'>
                                <div className='text-[12px]'>{ABILITY_POINTS_DICT[item]}</div>
                            </div>
                        )}
                    </div>
                </div>
                <div className='flex-1 flex flex-col bg-[white] rounded-[10px] p-[16px] text-[14px] min-w-[400px]'>
                    <div className='w-full pb-[4px]'>成績能力點</div>
                    <div className='w-full flex flex-row items-start justify-start flex-wrap gap-[16px] rounded-[10px] p-[6px] text-[black]'>
                        {getAbilityPointsData().map((item,index)=>
                            <div key={index} className='p-[24px] flex flex-col items-center justify-center max-w-[200px]'>
                                <div className='text-[12px] h-[60px]'>{ABILITY_POINTS_DICT[item.label]}</div>
                                <AbilityPieChart data={item}/>
                            </div>
                        )}
                    </div>
                </div>
            </div>



      

        </div>
    );
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
